import React from 'react';
import { Jumbotron, Container } from 'react-bootstrap';
import Heading from './Heading';

const JumboContainer = ({ id, eyebrow, title, subtitle, children, white }) => (
  <Jumbotron id={id} style={{backgroundColor: white && 'white', margin: 0}}>
    <Container>
      {title && <Heading eyebrow={eyebrow} title={title} subtitle={subtitle} /> }
      { children }
    </Container>
  </Jumbotron>
)

export default JumboContainer;